(function () {
  var dismissedUntilKey = 'beautytrend:newsletter-popup:dismissed-until';
  var subscribedKey = 'beautytrend:newsletter-popup:subscribed';
  var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      return;
    }
  }

  function initializePopups() {
    var popups = document.querySelectorAll('[data-beautytrend-newsletter-popup]');

    popups.forEach(function (popup) {
      if (popup.dataset.initialized === 'true') {
        return;
      }

      popup.dataset.initialized = 'true';

      var delaySeconds = Number(popup.dataset.delaySeconds) || 4;
      var dismissDays = Number(popup.dataset.dismissDays) || 30;
      var successMessage = popup.querySelector('[data-newsletter-success]');
      var errorMessage = popup.querySelector('[data-newsletter-error]');
      var pageSignupSuccess = document.querySelector('[data-vip-newsletter-success], .newsletter .note--success');
      var copyButton = popup.querySelector('[data-copy-code]');
      var timer = null;
      var isOpen = false;
      var previousFocus = null;
      var previousBodyOverflow = '';

      function isDismissed() {
        var dismissedUntil = Number(readStorage(dismissedUntilKey)) || 0;
        return dismissedUntil > Date.now();
      }

      function rememberDisplay() {
        var expiry = Date.now() + dismissDays * 24 * 60 * 60 * 1000;
        writeStorage(dismissedUntilKey, String(expiry));
      }

      function getFocusableElements() {
        return Array.prototype.slice.call(popup.querySelectorAll(focusableSelector)).filter(function (element) {
          return element.getClientRects().length > 0;
        });
      }

      function openPopup(force, remember) {
        if (isOpen) {
          return true;
        }

        if (!force && (readStorage(subscribedKey) === 'true' || isDismissed())) {
          return false;
        }

        if (remember !== false) {
          rememberDisplay();
        }

        previousFocus = document.activeElement;
        previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        isOpen = true;

        window.requestAnimationFrame(function () {
          popup.classList.add('is-open');
        });

        window.requestAnimationFrame(function () {
          var target = popup.querySelector('[data-copy-code]') && successMessage
            ? popup.querySelector('[data-copy-code]')
            : popup.querySelector('input[type="email"]');

          if (!target) {
            target = popup.querySelector('[data-popup-close]');
          }

          if (target) {
            target.focus({ preventScroll: true });
          }
        });

        return true;
      }

      function closePopup(remember) {
        if (!isOpen) {
          return;
        }

        if (remember !== false) {
          rememberDisplay();
        }

        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = previousBodyOverflow;
        isOpen = false;

        window.setTimeout(function () {
          if (!isOpen) {
            popup.hidden = true;
          }
        }, 240);

        if (previousFocus && typeof previousFocus.focus === 'function' && document.contains(previousFocus)) {
          previousFocus.focus({ preventScroll: true });
        }
      }

      popup.addEventListener('click', function (event) {
        if (event.target === popup || event.target.closest('[data-popup-close]')) {
          closePopup(true);
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!isOpen) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup(true);
          return;
        }

        if (event.key === 'Tab') {
          var focusableElements = getFocusableElements();
          var firstElement = focusableElements[0];
          var lastElement = focusableElements[focusableElements.length - 1];

          if (!firstElement) {
            event.preventDefault();
            return;
          }

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        }
      });

      if (copyButton) {
        copyButton.addEventListener('click', async function () {
          var codeElement = popup.querySelector('[data-discount-code]');
          var status = popup.querySelector('[data-copy-status]');
          var code = codeElement ? codeElement.textContent.trim() : 'GLOW10';

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code);
            } else {
              var temporaryInput = document.createElement('textarea');
              temporaryInput.value = code;
              temporaryInput.setAttribute('readonly', '');
              temporaryInput.style.position = 'fixed';
              temporaryInput.style.left = '-9999px';
              document.body.appendChild(temporaryInput);
              temporaryInput.select();
              var copied = document.execCommand('copy');
              temporaryInput.remove();

              if (!copied) {
                throw new Error('Copy failed');
              }
            }

            if (status) {
              status.textContent = 'Rabattkoden er kopiert.';
            }
          } catch (error) {
            if (status) {
              status.textContent = 'Kopier rabattkoden GLOW10 manuelt.';
            }
          }
        });
      }

      document.addEventListener('reminder:openNewsletter', function () {
        openPopup(true);
      });

      if (popup.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', function (event) {
          if (event.detail && event.detail.sectionId === popup.dataset.sectionId) {
            openPopup(true, false);
          }
        });

        document.addEventListener('shopify:section:deselect', function (event) {
          if (event.detail && event.detail.sectionId === popup.dataset.sectionId) {
            closePopup(false);
          }
        });

        return;
      }

      if (successMessage) {
        var alreadySubscribed = readStorage(subscribedKey) === 'true';
        writeStorage(subscribedKey, 'true');

        if (!alreadySubscribed) {
          openPopup(true);
        }

        return;
      }

      if (pageSignupSuccess) {
        writeStorage(subscribedKey, 'true');
        return;
      }

      if (errorMessage) {
        openPopup(true);
        return;
      }

      if (window.location.pathname === '/challenge' || window.location.pathname === '/password') {
        return;
      }

      if (readStorage(subscribedKey) === 'true' || isDismissed()) {
        return;
      }

      timer = window.setTimeout(function () {
        openPopup(false);
      }, delaySeconds * 1000);

      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        document.addEventListener('mouseout', function (event) {
          if (event.clientY <= 0 && !event.relatedTarget) {
            window.clearTimeout(timer);
            openPopup(false);
          }
        }, { once: true });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePopups, { once: true });
  } else {
    initializePopups();
  }

  document.addEventListener('shopify:section:load', initializePopups);
})();
